import { render, staticRenderFns } from "./BellOutline.vue?vue&type=template&id=0a800d4c&"
import script from "./BellOutline.vue?vue&type=script&lang=js&"
export * from "./BellOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports